import React, { ChangeEvent, useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { Input } from '@ktag/styleguide/dist/react';
import useAppState from '../../../AppStore';
import DrawControlsLabel from './DrawControlsLabel';

const TextSetting = () => {
  const { t } = useTranslation('agisviewer');
  const selectedFeatureId = useAppState((state) => state.selectedFeatureId);
  const drawFeatures = useAppState((state) => state.drawFeatures);
  const editDrawFeature = useAppState((state) => state.editDrawFeature);

  const feature = drawFeatures.find(({ id }) => id === selectedFeatureId)!;
  const [text, setText] = useState<string>(feature.properties.text || '');

  useEffect(() => {
    setText(feature.properties.text || '');
  }, [feature.properties.text]);

  const handleTextChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const newText = event.target.value;
    setText(newText);
    editDrawFeature(feature.id as string, {
      properties: {
        ...feature.properties,
        text: newText,
      },
    });
  };

  return (
    <div className="draw-settings__control">
      <DrawControlsLabel>{t('draw_text_label')}</DrawControlsLabel>
      <Input
        label={false}
        name="drawText"
        multiline
        value={text}
        onChange={handleTextChange}
        placeholder={t('draw_text_placeholder')}
      />
    </div>
  );
};

export default TextSetting;
